import moment, { Moment } from 'moment';
import getAngularService from './get_angular_service';

type Format =
  | 'date'
  | 'mediumDate'
  | 'DD-MMM-YYYY'
  | 'fromNow'
  | 'time'
  | 'MMM D, h:mma'
  | 'MMM D YYYY, h:mma'
  | 'D-MMM-YYYY'
  | 'ddd, MMM D, YYYY';

const formats = {
  'DD-MMM-YYYY': 'DD-MMM-YYYY',
  time: 'hh:mm A',
  date: 'MMM DD, YYYY',
  'MMM D, h:mma': 'MMM D, h:mma',
  'MMM D YYYY, h:mma': 'MMM D YYYY, h:mma',
  'D-MMM-YYYY': 'D-MMM-YYYY',
  'ddd, MMM D, YYYY': 'ddd, MMM D, YYYY',
};

const dateFormatter = (value: string | Date | Moment, format: Format = 'date') => {
  const filter = getAngularService('$filter');
  if (!value) return '';

  return formats[format] ? moment(value).format(formats[format]) : filter(format)(value);
};

export default dateFormatter;
